import { GridRowId, GridValidRowModel } from '@microservices/wiskey-react-table-component'

import { CONFIGURED_ENTITY_DATA_GRID_ROW_SYSTEM_UNIQUE_ID_FIELD_NAME } from '@constants'

export const applyUnsavedChanges = (
  data: GridValidRowModel[],
  unsavedChanges?: Record<GridRowId, GridValidRowModel>
) => {
  if (!unsavedChanges) return data

  return data.map(row => {
    const rowId = row._id || row[CONFIGURED_ENTITY_DATA_GRID_ROW_SYSTEM_UNIQUE_ID_FIELD_NAME]
    const changed = unsavedChanges.rows[rowId]
    const labels = unsavedChanges.labels[rowId]

    if (!changed) return row

    const updatedRow = { ...row, ...changed }

    if (labels && Object.keys(labels).length > 0) {
      for (const field in labels) {
        if (Object.hasOwn(labels, field)) {
          const value = changed[field]
          const label = labels[field]
          const option = value != null ? { id: value, label } : null

          updatedRow[field] = Array.isArray(label) ? label : option
        }
      }
    }

    return updatedRow
  })
}
